import merge from "lodash/merge";
import api from "./api";

function convertToPassBucketless(pass) {
  return merge(pass, {
    code: pass.pass_bucket.code,
    display_code: pass.pass_bucket.name,
    needed_supplementary_data: pass.pass_bucket.supplementary_data,
    barcode_hidden: pass.pass_bucket.hide_barcode_from_users,
    hidden_in_list: pass.pass_bucket.hide_from_users,
    needs_supplementary_data:
      pass.pass_bucket.supplementary_data &&
      (!pass.pass_bucket.supplementary_data.every(d => {
        return !d.required || pass.supplementary_data[d.key];
      }) ||
        !pass.name ||
        pass.name === "Unnamed Pass")
  });
}

export default {
  convertToPassBucketless: convertToPassBucketless,

  edit(id, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${id}`,
          json: {
            name: values.name,
            supplementary_data:
              values.supplementary_data &&
              JSON.stringify(values.supplementary_data)
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  },

  transfer(id, destinationEmail, token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${id}/transfer`,
          json: {
            token: token,
            destination_email: destinationEmail
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  },

  resendTransfer(id, token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${id}/resend_transfer`,
          json: { token }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  },

  cancelTransfer(id, token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${id}/cancel_transfer`,
          json: { token }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  },

  acceptTransfer(id, transferToken, personToken) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${id}/accept_transfer`,
          json: { transfer_token: transferToken, token: personToken }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  },

  sendGiftPass(id, opts, token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/${id}/send_gift`,
          json: {
            token,
            email: opts.email,
            message: opts.message
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/PassUtil.js